import { DatePipe } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  ValidatorFn,
  Validators,
} from '@angular/forms';
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { UserManagementService } from 'src/app/Service/user-management.service';
const trimValidator: ValidatorFn = (text: FormControl) => {
  if (text.value.startsWith(' ')) {
    return {
      trimError: { value: 'text has leading whitespace' },
    };
  }
  if (text.value.endsWith(' ')) {
    return {
      trimError: { value: 'text has trailing whitespace' },
    };
  }
  return null;
};

@Component({
  selector: 'app-manage-crop',
  templateUrl: './manage-crop.component.html',
  styleUrls: ['./manage-crop.component.scss'],
})
export class ManageCropComponent implements OnInit {
  form: FormGroup;
  submitted = false;
  uploadedImage: File;
  cropForm: FormGroup;
  success;
  insertscheme;
  alertMessage: any;
  // getGovtSchemes: any[];
  dataSource: any;
  selectedIndex: number;
  paginator: any;
  reg: string | RegExp;
  cropdata;
  cropdatalist = [];
  cropId;

  manageCrop: any[];
  constructor(
    private datepipe: DatePipe,
    private router: Router,
    private spinner: NgxSpinnerService,
    private fb: FormBuilder,
    public _userService: UserManagementService,
    public toastr: ToastrService,
    private dialog: MatDialog,
    public dialogRef: MatDialogRef<ManageCropComponent>
  ) {}

  ngOnInit(): void {
    this.cropForm = this.fb.group({
      cropName: ['', [Validators.required, Validators.pattern(/^(\s+\S+\s*)*(?!\s).*$/)]],
      // unit: ['', [Validators.required]],
    });

    this.spinner.show();

    setTimeout(() => {
      this.spinner.hide();
    }, 4000);

    let cropName = '';
    let result = cropName.trim();
    this.getManageCrop();
  }

  getcategoryId(id) {
    this.cropId = id;
  }

  getManageCrop() {
    this._userService.getCropList().subscribe((data) => {
      this.cropdata = data;
      this.cropdatalist = this.cropdata.result.data;
    });
  }

  getActiveCropList() {
    this.spinner.show();
    var postdata = {
      removeCropList: this.selectedItems,
    };
    this._userService.getActiveCrop(postdata).subscribe((data) => {
      this.alertMessage = data['result'];
    });
    return this.alertMessage;
  }

  addManageCropList() {
    var manageCropPostData = {
      cropName: this.cropForm.value.cropName,
      // "unit": this.cropForm.value.unit,
    };
   if(this.cropForm.valid){
    this._userService.addManageCrop(manageCropPostData).subscribe((data) => {
      if (data['result'].data == 1) {
        this.toastr.success(data['result'].message, 'Success', {
          timeOut: 3000,
        });
        this.cropForm.reset();
        this.getManageCrop();
      } else {
        this.toastr.error(data['result'].message, 'Error', {
          timeOut: 3000,
        });
      }
    });
   }else{
    this.toastr.error("Please fill the crop name")
   }

    this.getManageCrop();
  }

  onSubmit() {
    if (this._userService.form.valid) {
      this._userService.insertscheme(this._userService.form.value);
      this._userService.form.reset();
      // this._userService.initializeFormGroup();
      this._userService.success('Submitted successfully');
      this.onClear();
    }
  }
  selectedItems: any = [];
  itemToDelete(cropItems, event) {
    if (this.selectedItems.find((x) => x == cropItems)) {
      this.selectedItems.splice(this.selectedItems.indexOf(cropItems), 1);
    } else {
      this.selectedItems.push(cropItems);
    }
  }

  onClear() {
    this.dialogRef.close();
    // setTimeout("location.reload(true);", 500);
    this.router.navigate(['/MarketPlace']);
  }
  /*model pop up same page  */
  deletemarket() {
    if (this.selectedItems.length > 0) {
      var postdata = {
        removeCropList: this.selectedItems,
      };
      this._userService.getActiveCrop(postdata).subscribe((resp) => {
        if (resp['result']['data'] == 1) {
          var dialogRef = this.dialog.open(DeleteManageCrop, {
            width: '35%',
            height: '36%',
          });
          dialogRef.afterClosed().subscribe((result) => {
            if (result.result === 'Yes') {
              this.selectedItems.map((ele) => {
                ele.remark = result.remark;
                delete ele.cropName;
              });
              const deleteBody = {
                removeCropList: this.selectedItems,
              };
              this._userService
                .removeManageCrop(deleteBody)
                .subscribe((data) => {
                  if (data['result'].data == 1) {
                    this.toastr.success(data['result'].message, 'Success', {
                      timeOut: 3000,
                    });
                    this.selectedItems = [];
                    this.getManageCrop();
                  }
                });
            }
          });
        } else {
          this.toastr.error(resp['result']['message'], 'Error', {
            timeOut: 3000,
          });
        }
      });
    } else {
      this.toastr.warning('Please select any one crop!', 'Info', {
        timeOut: 3000,
      });
    }
  }
}
/* */
@Component({
  selector: 'delete-manage-crop',
  templateUrl: 'delete-manage-crop.html',
})
export class DeleteManageCrop {
  formDelete: FormGroup;
  response;
  cropId;

  constructor(
    public dialogRef: MatDialogRef<DeleteManageCrop>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    public _userService: UserManagementService,
    public toastr: ToastrService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.formDelete = this.fb.group({
      //  categoryID: ['', [Validators.required]],
      // marketName: ['', [Validators.required]],
      Remark: ['', [Validators.required]],
    });
  }
  onSubmit(value: any) {
    if (this.formDelete.valid) {
      var deleteItems = {
        result: value,
        remark: this.formDelete.value.Remark,
      };

      this.dialogRef.close(deleteItems);
    } else {
      alert('Please Enter the valid remark!');
    }
  }
  onNoClicks(value): void {
    this.dialogRef.close(value);
  }

  get f() {
    return this.formDelete.controls;
  }
}
